import { capitalizeFirstLetter } from '../../../../OvernightServicePreferencesContainer/helpers';

export const formatSpecialtySlug = (slug: string) => `${capitalizeFirstLetter(slug)}`.replace(/_/g, ' ');
